import { useContext } from 'react';
import { PermissionContext } from './PermissionProvider';

// Same values as `CLAIM_DETAIL_DISPLAY_TYPE` in
// features/claim/shared/constants/displayType.js — repeated as literals because
// shared/ must not import from features/ (layer rule). This hook is the single
// place that normalizes the raw BE `display_type`.
const MENU_TAB = 'MENU_TAB';
const SCROLL_CARD = 'SCROLL_CARD';

/**
 * Normalizes the raw BE `display_type`. Only an explicit `MENU_TAB`
 * (case-insensitive) opts into the SA-2092 layout; missing / null / unknown
 * values fall back to the legacy SCROLL_CARD layout.
 *
 * @param {unknown} raw
 * @returns {'MENU_TAB'|'SCROLL_CARD'}
 */
export const normalizeClaimDetailDisplayType = (raw) => {
  const value = String(raw ?? '')
    .trim()
    .toUpperCase();
  return value === MENU_TAB ? MENU_TAB : SCROLL_CARD;
};

/**
 * useClaimDetailDisplayType — reactive claim-detail layout for the Permission
 * Access Layer (SA-2092).
 *
 * `claim_detail_setting` rides inside the `company` blob that
 * `applyPermissionsFromMe` rewrites on login and token refresh, so the
 * PermissionProvider projection keeps it current. Pattern mirrors
 * `useAnalyticFormat`.
 *
 * @returns {'MENU_TAB'|'SCROLL_CARD'}
 */
export const useClaimDetailDisplayType = () => {
  const { company } = useContext(PermissionContext);
  return normalizeClaimDetailDisplayType(
    company?.claim_detail_setting?.display_type
  );
};
